<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div>
      <md-card class="card" style="margin: 1rem">
        <md-card-content>
          <md-layout md-gutter>
            <md-layout md-flex="45"></md-layout>
            <md-layout md-flex="50">
              <h3><b>Item MIS Report</b></h3>
              <md-layout md-flex="10"></md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-s" />

          <b-row
            v-if="
              (itemMaster.itemId > 0 && $sessionsStorage.get('designation') == 'Admin') ||
              $sessionsStorage.get('designation') == 'HOD'
            "
          >
            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Item Name <span class="error">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="itemName"
                  name="itemName"
                  v-model="itemMaster.itemName"
                  :disabled="itemMaster.itemId == '' ? false : true"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.itemName">{{ itemNameError }}</span>
            </b-col>

            <b-col md="2" class="mb-1">
              <md-layout md-flex="100">
                <label>Part Number <span class="error mb-1">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="part_number"
                  name="part_number"
                  v-model="itemMaster.part_number"
                  :disabled="itemMaster.itemId == '' ? false : true"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.part_number">{{
                partNumberError
              }}</span>
            </b-col>

            <b-col md="2" class="mb-1">
              <md-layout md-flex="100">
                <label>Stocked-In Quantity <span class="error mb-1">*</span></label>
                <b-form-input
                  type="number"
                  min="0"
                  :formatter="capitalizeAll"
                  id="quantity"
                  name="quantity"
                  v-model="itemMaster.quantity"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.quantity">{{ quantityError }}</span>
            </b-col>

            <b-col md="3" class="mb-1">
              <md-layout md-flex="100">
                <label>Rate Per Quantity <span class="error mb-1">*</span></label>
                <b-form-input
                  :formatter="capitalizeAll"
                  type="number"
                  min="1"
                  id="ratePerUnit"
                  name="ratePerUnit"
                  v-model="itemMaster.ratePerUnit"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!itemMaster.ratePerUnit">{{
                ratePerUnitError
              }}</span>
            </b-col>

            <b-col md="1" class="mt-5 mb-1">
              <b-button
                variant="primary"
                size="sm"
                class="py-2"
                @click="addItem"
                id="addButtonLoader"
              >
                {{ itemMaster.itemId == "" ? "Add New Item" : "Update Item" }}
              </b-button>
            </b-col>

            <b-col md="1" class="mt-5 mb-1">
              <b-button
                v-if="itemMaster.itemId != '' && itemMaster.unit == 'pcs'"
                @click="openQuantityModal(itemMaster.itemId, 'yes')"
                variant="info"
                id="quantityDetailsButton"
                size="sm"
                class="py-2"
              >
                Sub-Item Details
              </b-button>
            </b-col>
          </b-row>

          <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            ref="Item-modal"
            title="Sub Item List"
            centered
          >
            <b-col md="12">
              <b-button
                class="mb-2"
                variant="primary"
                @click="openQuantityModal(itemMaster.itemId, '')"
              >
                All Items
              </b-button>

              <b-button
                class="mb-2"
                variant="primary"
                @click="openQuantityModal(itemMaster.itemId, 'yes')"
              >
                Show Only Stocked-In items
              </b-button>

              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="subItemfilter"
                    placeholder="Type to Search sub Item"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!subItemfilter" @click="subItemfilter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false"
                      >{{ totalRowsSubItem }} Sub Items</small
                    >
                  </h5>
                </b-input-group>
              </b-form-group>
            </b-col>

            <div class="table-responsive tableMain">
              <b-table
                show-empty
                stacked="md"
                :items="subItemList"
                :fields="subItemfields"
                :current-page="currentPage"
                :per-page="perPageSubItem"
                :filter="subItemfilter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onSubItemFiltered"
              >
                <template slot="itemId" slot-scope="row0">
                  <span>{{ row0.index + 1 + (currentPage - 1) * perPageSubItem }}</span>
                </template>

                <template slot="subItemName" slot-scope="row1">
                  <span>{{ row1.item.sub_item_name }}</span>
                </template>

                <template slot="serialNo" slot-scope="row2">
                  <span>{{ row2.item.sub_item_code }}</span>
                </template>

                <template slot="installationDate" slot-scope="row3">
                  <span>{{ row3.item.installation_date }}</span>
                </template>

                <template slot="manufacturingDate" slot-scope="row4">
                  <span>{{ row4.item.manufacture_date }}</span>
                </template>

                <template slot="expiryDate" slot-scope="row5">
                  <span>{{ row5.item.expiry_date }}</span>
                </template>

                <template slot="stockReceivedDate" slot-scope="row6">
                  <span>{{ row6.item.sub_item_received_date }}</span>
                </template>

                <template slot="stockReceivedBy" slot-scope="row7">
                  <span>{{ row7.item.receivedBy }}</span>
                </template>

                <template slot="stockoutdate" slot-scope="row8">
                  <span>{{ row8.item.sub_item_stockout_date }}</span>
                </template>
              </b-table>
            </div>

            <b-row>
              <b-col md="12" class="my-1">
                <b-pagination
                  limit="25"
                  :total-rows="totalRowsSubItem"
                  :per-page="perPageSubItem"
                  v-model="currentPage"
                  class="my-0 pull-right"
                />
              </b-col>
            </b-row>
          </b-modal>

          <hr />
          <div class="box">
            <div class="box-header">
              <h3 class="box-title"><b>Item Details</b></h3>
              <b-row class="gutr">
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="filter"
                        placeholder="Search Item Name / Item Detail Here"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    :list="statusList"
                    v-model="itemStatusFilter"
                    option-value="statusVal"
                    option-text="statusText"
                    placeholder="Select Status"
                    @input="viewitemDetail('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="4">
                  <b-button
                    class="md-2 mb-3"
                    size="sm"
                    variant="warning"
                    @click="StockTransfer()"
                  >
                    Stock Transfer
                  </b-button>
                  <b-button
                    :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                    class="md-2 mb-3"
                    size="sm"
                    variant="warning"
                    @click="viewitemDetail('Excel')"
                  >
                    {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </b-button>
                  <b-button
                    class="md-2 mb-3 ml-1"
                    :disabled="ExcelBtnName1 != 'Export SubItem As Excel' ? true : false"
                    @click="getExportExcelSubItemList()"
                    size="sm"
                    style="font-size: 0.675rem"
                    variant="warning"
                  >
                    {{ ExcelBtnName1 }}
                    <b-spinner
                      v-if="ExcelBtnName1 != 'Export SubItem As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>

                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Items</small>
                  </h5>
                </b-col>
              </b-row>
            </div>

            <div class="table-responsive tableMain">
              <b-table
                show-empty
                stacked="md"
                :items="stockList"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <template slot="itemId" slot-scope="row0">
                  <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                </template>

                <!-- <template slot="itemcode" slot-scope="row1">
                  <span>{{row1.item.itemCode}}</span>
                </template> -->

                <template slot="itemName" slot-scope="row2">
                  <span>{{ row2.item.itemName }}</span>
                  <br />
                  <b-button
                    v-if="row2.item.unit == 'pcs' && row2.item.itemId"
                    variant="primary"
                    size="sm"
                    style="font-size: 0.675rem"
                    class="py-2"
                    @click="openUpdateSubItemModal(row2.item)"
                    id="addButtonLoader"
                  >
                    Sub Item's
                  </b-button>
                  <!-- <span>{{ row2.item.unit }}</span> -->
                </template>

                <template slot="itemCategory" slot-scope="row3">
                  <span>{{ row3.item.item_category }}</span>
                </template>

                <template slot="partNumber" slot-scope="row4">
                  <span>{{ row4.item.part_number }}</span>
                </template>

                <template slot="sparePartLocation" slot-scope="row5">
                  <span>{{ row5.item.spare_part_location }}</span>
                </template>

                <template slot="loc_name" slot-scope="row6">
                  <span>{{ row6.item.loc_name }}</span>
                </template>
                <template slot="work_loc_name" slot-scope="row6">
                  <span>{{ row6.item.work_loc_name }}</span>
                </template>

                <template slot="ratePerUnit" slot-scope="row7">
                  <!-- <span>{{row7.item.ratePerUnit
                  }}</span> -->
                  <span>{{
                    row7.item.FirstpoRatePerUnit == ""
                      ? row7.item.ratePerUnit
                      : row7.item.ratePerUnit
                      ? row7.item.ratePerUnit
                      : row7.item.FirstpoRatePerUnit
                  }}</span>
                </template>

                <template slot="unit" slot-scope="row14">
                  <span>{{ row14.item.unit }}</span>
                </template>

                <template slot="quantityAvailable" slot-scope="row8">
                  <span
                    v-if="
                      parseInt(row8.item.quantity) - parseInt(row8.item.stockOutNumber) >
                      0
                    "
                    >{{
                      parseInt(row8.item.stockOutNumber) == 0
                        ? row8.item.quantity
                        : parseInt(row8.item.quantity) -
                          parseInt(row8.item.stockOutNumber)
                    }}</span
                  >
                  <span class="error" v-else> <b>Out of stock</b> </span>
                </template>

                <template slot="totalStockIn" slot-scope="row9">
                  <span>{{ row9.item.quantity }}</span>
                </template>

                <template slot="stockOutNumber" slot-scope="row10">
                  <span>{{
                    row10.item.stockOutNumber ? row10.item.stockOutNumber : 0
                  }}</span>
                </template>

                <template slot="maintenanceType" slot-scope="row11">
                  <span>{{ row11.item.maintenance_type }}</span>
                </template>

                <template slot="remarks" slot-scope="row12">
                  <span>{{ row12.item.remarks }}</span>
                </template>

                <!-- <template slot="isActiveItem" slot-scope="row12">
                  <div v-if="adminToggle == 'Admin'" :id="'row' + row12.item.itemId">
                    <md-switch :id="'approval' + row12.item.itemId" name="approval" class="md-primary"
                      :value="row12.item.isActiveItem == 1 ? true : false" @change="activateItem(row12.item)">
                      <h6>
                        <br />
                        <b-badge style="margin-left: -45px">{{
                          row12.item.isActiveItem == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </md-switch>
                  </div>
                </template> -->
                <template slot="view" slot-scope="row13">
                  <b-button
                    class="pull-right ml-1 mt-1"
                    v-if="row13.item.stockLogArr.length > 0"
                    :disabled="row13.item.stockLogArr.length <= 0 ? true : false"
                    @click="StockItemTransfer('stocklog', row13.item)"
                    size="sm"
                    variant="warning"
                    style="font-size: 0.675rem"
                    >Stock Transfer History</b-button
                  >
                  <b-button
                    class="pull-right ml-1 mt-1"
                    v-if="row13.item.logArr.length > 0"
                    :disabled="row13.item.logArr.length <= 0 ? true : false"
                    @click="StockItemTransfer('itemlog', row13.item)"
                    size="sm"
                    variant="warning"
                    style="font-size: 0.675rem"
                    >Item Log History</b-button
                  >
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="viewItemPage(row13.item.itemId)"
                    v-if="
                      $sessionsStorage.get('designation') == 'Admin' ||
                      $sessionsStorage.get('designation') == 'HOD'
                    "
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                </template>
              </b-table>
            </div>

            <b-row>
              <b-col md="12" class="my-1">
                <b-pagination
                  limit="25"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0 pull-right"
                />
              </b-col>
            </b-row>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- Subitem List Modal Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Sub-Item-Modal"
      hide-footer
      :title="'Sub Item List'"
    >
      <b-table show-empty stacked="md" :items="PS_subItemList" :fields="PS_subItemFields">
        <template slot="SN" slot-scope="row0">
          <span>{{ row0.index + 1 }}</span>
        </template>
        <template slot="is_quanity" slot-scope="row1">
          <div :id="'row' + row1.item.lead_id">
            <md-switch
              :id="'approval' + row1.item.lead_id"
              name="approval"
              class="md-primary"
              :value="row1.item.is_quanity == 1 ? true : false"
              @change="isQuanityMinus(row1.item)"
              :disabled="true"
            >
              <!-- ($sessionsStorage.get('designation') != 'Admin' && -->
              <!-- $sessionsStorage.get('nameUser') != 'Bhavneesh') || -->
              <h6>
                <br />
                <b-badge :variant="row1.item.is_quanity == 1 ? 'success' : 'danger'">{{
                  row1.item.is_quanity == 1 ? "Done" : "Pending"
                }}</b-badge>
              </h6>
            </md-switch>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col md="12"> </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideSubItemModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Subitem List Modal End -->

    <!-- Item Modal Added By Priyanshu Singh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Stock-Transfer-modal"
      hide-footer
      :title="`Stock Transfer`"
    >
      <b-row>
        <b-col md="3">
          <label>Item Name <span class="error">*</span></label>
          <model-list-select
            :list="stockList"
            v-model="ItemStockModal.itemId"
            option-value="itemId"
            option-text="itemName"
            placeholder="Select Item"
            @input="getItemData(ItemStockModal.itemId)"
            :style="{
              borderColor:
                !ItemStockModal.itemId && errorStockItemList.itemId ? 'red' : '',
            }"
          ></model-list-select>
          <span class="error" v-if="!ItemStockModal.itemId">{{
            errorStockItemList.itemId
          }}</span>
        </b-col>
        <b-col md="3">
          <label>From Location<span class="error">*</span></label>
          <model-list-select
            :isDisabled="true"
            :list="$store.getters['common/getAllBranchList']"
            v-model="ItemStockModal.fk_old_loc_id"
            option-value="pickupId"
            option-text="pickupLocation"
            placeholder=" Location"
            :style="{
              borderColor:
                !ItemStockModal.fk_old_loc_id && errorStockItemList.fk_old_loc_id
                  ? 'red'
                  : '',
            }"
            @input="getStockLocDetails(ItemStockModal.fk_old_loc_id)"
          ></model-list-select>
          <span class="error" v-if="!ItemStockModal.fk_old_loc_id">{{
            errorStockItemList.fk_old_loc_id
          }}</span>
        </b-col>
        <b-col md="3">
          <label>Old Quantity<span class="error">*</span></label>
          <b-form-input
            disabled
            type="number"
            min="0"
            :formatter="capitalizeAll"
            id="old_quantity"
            name="old_quantity"
            v-model="ItemStockModal.old_quantity"
            :style="{
              borderColor:
                !ItemStockModal.old_quantity && errorStockItemList.old_quantity
                  ? 'red'
                  : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!ItemStockModal.old_quantity">{{
            errorStockItemList.old_quantity
          }}</span>
        </b-col>
        <b-col md="3">
          <label>Old Rate Per Unit<span class="error">*</span></label>
          <b-form-input
            disabled
            type="number"
            min="0"
            :formatter="capitalizeAll"
            id="ratePerUnit"
            name="ratePerUnit"
            v-model="ItemStockModal.ratePerUnit"
            :style="{
              borderColor:
                !ItemStockModal.ratePerUnit && errorStockItemList.ratePerUnit
                  ? 'red'
                  : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!ItemStockModal.ratePerUnit">{{
            errorStockItemList.ratePerUnit
          }}</span>
        </b-col>

        <b-col md="3">
          <label>Location<span class="error">*</span></label>
          <model-list-select
            :list="$store.getters['common/getAllBranchList']"
            v-model="ItemStockModal.fk_loc_id"
            option-value="pickupId"
            option-text="pickupLocation"
            placeholder=" Location"
            :style="{
              borderColor:
                !ItemStockModal.fk_loc_id && errorStockItemList.fk_loc_id ? 'red' : '',
            }"
            @input="getStockLocDetails(ItemStockModal.fk_loc_id)"
          ></model-list-select>
          <span class="error" v-if="!ItemStockModal.fk_loc_id">{{
            errorStockItemList.fk_loc_id
          }}</span>
        </b-col>

        <b-col md="3">
          <label>Quantity<span class="error">*</span></label>
          <b-form-input
            type="number"
            min="0"
            :formatter="capitalizeAll"
            id="quantity"
            name="quantity"
            v-model="ItemStockModal.quantity"
            :style="{
              borderColor:
                !ItemStockModal.quantity && errorStockItemList.quantity ? 'red' : '',
            }"
          ></b-form-input>
          <span class="error" v-if="!ItemStockModal.quantity">{{
            errorStockItemList.quantity
          }}</span>
        </b-col>
        <b-col md="12" v-if="ItemStockModal.LocationErr">
          <span class="error" v-if="ItemStockModal.LocationErr">
            {{ ItemStockModal.LocationErr }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            :disabled="ItemDisabled"
            variant="outline-primary"
            @click="saveStockTransfer"
            id="addButtonLoader"
            size="sm"
            >Save</b-button
          >
          <b-button
            variant="outline-danger"
            class="ml-2"
            size="sm"
            @click="hideStockTransferModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <!-- Subitem List Modal Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Stock-Item-Modal"
      hide-footer
      :title="StockModalType + ' List'"
    >
      <b-row>
        <b-col
          cols="12"
          class="text-center"
          v-if="StockModalType == 'Stock Transfer Log History'"
        >
          <b-table
            responsive
            primary-key="id_email_section"
            :filter="filter"
            show-empty
            stacked="md"
            :items="stockLogArr"
            :fields="StockLogFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 }}</span>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="text-center" v-if="StockModalType == 'Item Log History'">
          <b-table
            responsive
            primary-key="id_email_section"
            :filter="filter"
            show-empty
            stacked="md"
            :items="logArr"
            :fields="logFields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 }}</span>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideStockItemModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Subitem List Modal End -->
    <!-- Item Modal Added By Priyanshu Singh Start -->

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import { ModelListSelect } from "vue-search-select";
import MaintenanceService from "../../../services/MaintenanceService.js";
import ClientUserService from "../../../services/ClientUserService.js";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/itemMaster/itemMaster");
      this.viewitemDetail("Normal");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      StockModalType: "Item Log History",
      stockLogArr: [],
      StockItemListFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "ParentItemName",
          mainkey: "ParentItemName",
          label: "From Item",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "childeItemName",
          mainkey: "childeItemName",
          label: "To Item",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "item_quantity",
          mainkey: "item_quantity",
          label: "Stock",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "old_qty",
          mainkey: "old_qty",
          label: "Old Stock",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "new_qty",
          mainkey: "new_qty",
          label: "New Stock",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updateStatus",
          mainkey: "updateStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },

        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "log_created_at",
          mainkey: "log_created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      logFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "itemName",
          mainkey: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "field_changed",
          mainkey: "field_changed",
          label: "Field Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "item_quantity",
          mainkey: "item_quantity",
          label: "Quantity",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "item_ratePerUnit",
          mainkey: "item_ratePerUnit",
          label: "Rate Per Unit",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "old_value",
          mainkey: "old_value",
          label: "Old Value",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "new_value",
          mainkey: "new_value",
          label: "New Value",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "logStatus",
          mainkey: "logStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },

        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "log_created_at",
          mainkey: "log_created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      logArr: [],
      ItemDisabled: false,
      adminToggle: this.$sessionsStorage.get("designation"),
      itemStatusFilter: "1",
      statusList: [
        {
          statusVal: "",
          statusText: "All",
        },
        {
          statusVal: "1",
          statusText: "Active",
        },
        {
          statusVal: "0",
          statusText: "In-Active",
        },
      ],
      PS_subItemList: [],
      PS_subItemFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "itemName",
          mainkey: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "sub_item_name",
          mainkey: "sub_item_name",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sub_item_code",
          mainkey: "sub_item_code",
          label: "Sub Item Code",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "is_quanity",
          mainkey: "is_quanity",
          label: "Quantity",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "is_stcok_out",
          mainkey: "is_stcok_out",
          label: "Stock Out Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "createdBy",
          mainkey: "createdBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "created_at",
          mainkey: "created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updatedBy",
          mainkey: "updatedBy",
          label: "Updated By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updated_at",
          mainkey: "updated_at",
          label: "Updated Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export SubItem As Excel",

      subItemList: [],
      totalRowsSubItem: "",
      perPageSubItem: 5,
      subItemfilter: null,

      subItemfields: [
        {
          key: "itemId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "subItemName",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "serialNo",
          label: "Serial No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "installationDate",
          label: "Installation Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "manufacturingDate",
          label: "Manufacturing Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expiryDate",
          label: "Expiry Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedDate",
          label: "Stock Received Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedBy",
          label: "Stock Received By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockoutdate",
          label: "Stock Out Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      fields: [
        {
          key: "itemId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "itemCode",
        //   label: "Item Code",
        //   sortable: true,
        //   sortDirection: "desc"
        // },
        {
          key: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "itemCategory",
          label: "Item Category",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "partNumber",
          label: "Part Number",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "sparePartLocation",
          label: "Spare Part Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loc_name",
          label: "Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "work_loc_name",
          label: "Workshop Location",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ratePerUnit",
          label: "Rate Per Unit",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "unit",
          label: "Unit type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "quantityAvailable",
          label: "Available Quantity",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "totalStockIn",
          label: "Total Stock In",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockOutNumber",
          label: "Total Stock out",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "maintenanceType",
          label: "maintenance Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //    key: "isActiveItem",
        //   label: "Status",
        //   sortable: true,
        //   sortDirection: "desc",
        // },

        {
          key: "view",
          label: "View",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,

      isLoading: false,
      itemMaster: {
        itemId: "",
        itemName: "",
        itemCode: "",
        part_number: "",
        item_category: "",
        rackNo: "",
        shelfNo: "",
        quantity: "",
        unit: "",
        ratePerUnit: "",
        location: "",
        spare_part_location: "",
        workshop_location: "",
        maintenance_type: "",
        remarks: "",
      },

      itemNameError: "",
      partNumberError: "",
      itemCategoryError: "",
      quantityError: "",
      unitError: "",
      ratePerUnitError: "",
      sparePartLocError: "",
      workshopLocError: "",
      maintenanceTypeError: "",

      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      clientId: "",
      stockList: [],

      UnitList: [
        {
          unitVal: "pcs",
          unitText: "Pcs",
        },
        {
          unitVal: "small pcs",
          unitText: "Small Pcs",
        },
        {
          unitVal: "kg",
          unitText: "Kg",
        },
        {
          unitVal: "litre",
          unitText: "Litre",
        },
      ],

      maintenanceTypeList: [
        {
          maintenanceTypeVal: "transport",
          maintenanceTypeText: "Transport",
        },
        {
          maintenanceTypeVal: "yard",
          maintenanceTypeText: "Yard",
        },
        {
          maintenanceTypeVal: "office",
          maintenanceTypeText: "Office",
        },
      ],

      ItemStockModal: {
        itemId: "",
        itemName: "",
        itemNameCode: "",
        itemCode: "",
        stockOut: "",
        quantity: "",
        old_quantity: "",
        ratePerUnit: "",
        unit: "",
        rackNo: "",
        shelfNo: "",
        location: "",
        fk_loc_id: "",
        fk_old_loc_id: "",
        LocationErr: "",
        fk_workshop_loc_id: "",
        remarks: "",
        supplier_name: "",
        item_vendor_name: "",
        supplier_invoice_number: "",
        item_category: "",
        pridel_po_number: "",
        part_number: "",
        spare_part_location: "",
        workshop_location: "",
        maintenance_type: "",
        total_invoice_amount: "",
      },
      StockItemError: [
        "Please Enter Stock Item Name",
        "Please Enter Stock Location",
        "Please Enter Stock Quantity",
      ],
      errorStockItemList: {
        itemId: "",
        fk_loc_id: "",
        quantity: "",
      },
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
  },

  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    activateItem(item) {
      this.itemObj = item;

      this.itemObj.isActiveItem = this.itemObj.isActiveItem == 1 ? 0 : 1;
      let paylod = {
        tableName: "main_itemmaster",
        tableId: "itemId",
        tableIsActive: "isActiveItem",
        value1: this.itemObj.isActiveItem,
        tableVal: item.itemId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    openUpdateSubItemModal(item) {
      this.PS_subItemList = [];
      console.log("Item=>", item);
      let payload = {
        item_id: item.itemId,
        item_name: item.itemName,
        itemCode: "getSubItemList",
      };
      MaintenanceService.getAllMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.subItemList.length > 0) {
            this.PS_subItemList = data.subItemList;
            this.$refs["Sub-Item-Modal"].show();
          }
          console.log("subItemList=>", this.PS_subItemList);
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
    hideSubItemModal() {
      this.PS_subItemList = [];
      this.$refs["Sub-Item-Modal"].hide();
    },
    getExportExcelSubItemList() {
      this.ExcelBtnName1 = "Downloading Please Wait .....";
      let payload = {
        itemCode: "getExportExcelSubItemList",
        type: "Excell",
      };
      MaintenanceService.getAllMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.subItemList.length > 0) {
            this.ExcelBtnName1 = "Export SubItem As Excel";
            window.location.href =
              `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
          }
        })
        .catch((error) => {
          console.log("Catch on getExportExcelSubItemList Error: ", error);
        });
    },
    openQuantityModal(itemID, stockOut) {
      console.log("salil", itemID);
      // this.doLoading();
      this.$refs["Item-modal"].show();

      let payload = {
        view: "Quantity_details",
        itemID: itemID,
        stockOut: stockOut,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.subItemsArray.length > 0) {
              this.subItemList = data.subItemsArray;
              this.totalRowsSubItem = data.subItemsArray.length;
            } else {
              this.subItemList = [];
              this.totalRowsSubItem = "";
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    closeModal() {
      this.$refs["Item-modal"].hide();
    },

    onSubItemFiltered(filteredItems) {
      this.totalRowsSubItem = filteredItems.length;
      this.currentPage = 1;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewItemPage(itemID) {
      let array = this.stockList.filter((x) => {
        return x.itemId == itemID;
      });

      Object.keys(this.itemMaster).map((x) => {
        this.itemMaster[x] = array[0][x] || "";
      });
    },

    JqueryFun() {
      return $(function () {
        return $("#viewSalesBooking").DataTable();
      });
    },
    previousItemView() {},

    StockItemTransfer(type, item) {
      if (type == "stocklog") {
        this.stockLogArr = item.stockLogArr;
        this.StockModalType = "Stock Transfer Log History";
      } else if (type == "itemlog") {
        this.logArr = item.logArr;
        this.StockModalType = "Item Log History";
      }
      this.$refs["Stock-Item-Modal"].show();
    },
    hideStockItemModal() {
      this.StockModalType = "Item Log History";
      this.$refs["Stock-Item-Modal"].hide();
    },
    getItemData(itemId) {
      let arrayItem = this.stockList.filter((x) => {
        return x.itemId == itemId;
      });
      console.log("arrayItem>", arrayItem);
      if (arrayItem.length > 0) {
        // this.ItemStockModal.itemId = arrayItem[0].itemId;
        this.ItemStockModal.itemName = arrayItem[0].itemName;
        this.ItemStockModal.itemNameCode = arrayItem[0].itemNameCode;
        this.ItemStockModal.itemCode = arrayItem[0].itemCode;
        this.ItemStockModal.stockOut = arrayItem[0].stockOut;
        this.ItemStockModal.quantity = "";
        this.ItemStockModal.old_quantity = arrayItem[0].quantity;
        this.ItemStockModal.ratePerUnit = arrayItem[0].ratePerUnit;
        this.ItemStockModal.unit = arrayItem[0].unit;
        this.ItemStockModal.rackNo = arrayItem[0].rackNo;
        this.ItemStockModal.shelfNo = arrayItem[0].shelfNo;
        // this.ItemStockModal.location= "";
        this.ItemStockModal.fk_old_loc_id = arrayItem[0].fk_loc_id;
        // this.ItemStockModal.fk_loc_id= "";
        // this.ItemStockModal.fk_workshop_loc_id= "";
        this.ItemStockModal.remarks = arrayItem[0].remarks;
        this.ItemStockModal.supplier_name = arrayItem[0].supplier_name;
        this.ItemStockModal.item_vendor_name = arrayItem[0].item_vendor_name;
        this.ItemStockModal.supplier_invoice_number =
          arrayItem[0].supplier_invoice_number;
        this.ItemStockModal.item_category = arrayItem[0].item_category;
        this.ItemStockModal.pridel_po_number = arrayItem[0].pridel_po_number;
        this.ItemStockModal.part_number = arrayItem[0].part_number;
        this.ItemStockModal.spare_part_location = arrayItem[0].spare_part_location;
        // this.ItemStockModal.workshop_location= "";
        this.ItemStockModal.maintenance_type = arrayItem[0].maintenance_type;
        this.ItemStockModal.total_invoice_amount = arrayItem[0].total_invoice_amount;
      }
    },
    getStockLocDetails(fk_loc_id) {
      let arrayLoc = this.$store.getters["common/getAllBranchList"].filter((x) => {
        return x.pickupId == fk_loc_id;
      });
      if (arrayLoc.length > 0) {
        this.ItemStockModal.fk_workshop_loc_id = fk_loc_id;
        this.ItemStockModal.workshop_location = arrayLoc[0].pickupLocation;
        this.ItemStockModal.location = arrayLoc[0].pickupLocation;
      }
    },
    StockTransfer() {
      this.$refs["Stock-Transfer-modal"].show();
    },
    hideStockTransferModal() {
      this.ItemStockModal = {
        itemId: "",
        itemName: "",
        itemNameCode: "",
        itemCode: "",
        stockOut: "",
        quantity: "",
        old_quantity: "",
        ratePerUnit: "",
        unit: "",
        rackNo: "",
        shelfNo: "",
        location: "",
        fk_loc_id: "",
        LocationErr: "",
        fk_old_loc_id: "",
        fk_workshop_loc_id: "",
        remarks: "",
        supplier_name: "",
        item_vendor_name: "",
        supplier_invoice_number: "",
        item_category: "",
        pridel_po_number: "",
        part_number: "",
        spare_part_location: "",
        workshop_location: "",
        maintenance_type: "",
        total_invoice_amount: "",
      };
      this.ItemDisabled = false;
      this.$refs["Stock-Transfer-modal"].hide();
    },
    validateStockItem() {
      let validate_new = true;
      Object.keys(this.errorStockItemList).map((x, index) => {
        if (this.ItemStockModal[x] == "") {
          this.errorStockItemList[x] = this.StockItemError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    saveStockTransfer() {
      console.log("ItemStockModal=>", this.ItemStockModal);
      if (this.ItemStockModal.fk_old_loc_id && this.ItemStockModal.fk_loc_id) {
        if (this.ItemStockModal.fk_old_loc_id == this.ItemStockModal.fk_loc_id) {
          this.ItemStockModal.LocationErr =
            "Sorry You are not allowed add Quantity to Same Location!!";
          return false;
        }
      }
      let old_quantity = this.ItemStockModal.old_quantity;
      old_quantity = old_quantity && !isNaN(old_quantity) ? parseInt(old_quantity) : 0;
      // return false;
      this.validateStockItem();
      if (old_quantity <= 0) {
        this.ItemStockModal.LocationErr =
          "Sorry You are not allowed Item is Stocked Out!!";
        return false;
      }
      if (this.validate != false) {
        this.ItemDisabled = true;
        let payload = {
          itemCode: "upsertStockTransfer",
          itemDet: this.ItemStockModal,
        };
        MaintenanceService.getMaintenanceList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.hideStockTransferModal();
              this.ItemDisabled = false;
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.viewitemDetail("Normal");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on addItem Error: ", error);
          });
      }
    },

    viewitemDetail(type) {
      this.ExcelBtnName = "Downloading Please Wait...";

      if (type == "Normal") {
        this.doLoading();
        this.ExcelBtnName = "Export As Excel";
      }

      let payload = {
        view: "itemMaster",
        type: type,
        itemStatusFilter: this.itemStatusFilter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (type == "Excel") {
              if (data.itemArray.length > 0) {
                this.stockList = data.itemArray;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.itemArray.length > 0) {
                this.stockList = data.itemArray;
                this.totalRows = data.itemArray.length;
              }
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    onClose(type) {},

    validateItemMaster() {
      let validate_new = true;

      if (this.itemMaster.itemName == "") {
        $("#itemName").focus();
        this.itemNameError = "Item Name Required";
        validate_new = false;
      }

      if (this.itemMaster.part_number == "") {
        $("#part_number").focus();
        this.partNumberError = "Part Number Required";
        validate_new = false;
      }

      if (this.itemMaster.item_category == "") {
        $("#item_category").focus();
        this.itemCategoryError = "Item Category Required";
        validate_new = false;
      }

      if (this.itemMaster.quantity == "") {
        $("#quantity").focus();
        this.quantityError = "Qty Required";
        validate_new = false;
      }

      if (this.itemMaster.unit == "") {
        $("#unit").focus();
        this.unitError = "Unit Required";
        validate_new = false;
      } else {
        this.unitError = "";
      }

      if (this.itemMaster.ratePerUnit == "") {
        $("#ratePerUnit").focus();
        this.ratePerUnitError = "Enter Rate Per Unit";
        validate_new = false;
      } else {
        this.ratePerUnitError = "";
      }

      if (this.itemMaster.maintenance_type == "") {
        $("#maintenance_type").focus();
        this.maintenanceTypeError = "Select Maintenance Type";
        validate_new = false;
      } else {
        this.maintenanceTypeError = "";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addItem() {
      // let array = this.stockList.filter(x => {
      //   return (
      //     x.itemName == this.itemMaster.itemName &&
      //     x.itemCode == this.itemMaster.itemCode
      //   );
      // });

      // if (array.length > 0 && this.itemMaster.itemId == "") {
      //   this.alert.content = "Item Already Exists";
      //   this.$refs["addPop1"].open();

      //   return false;
      // }

      this.validateItemMaster();
      if (this.validate != false) {
        this.itemMaster.ModalAdd = "ItemMISRep";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addItem.php`,
          data: JSON.stringify(this.itemMaster),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");

              // if (this.itemMaster.itemId == "") {
              //   this.alert.content = "Data Added Successfully";
              // } else {
              //   this.alert.content = "Data Updated Successfully";
              // }

              this.isLoading = false;
              this.alert.content = data.msg;
              this.$refs["addPop"].open();

              Object.keys(this.itemMaster).map((x) => {
                this.itemMaster[x] = "";
              });
              this.viewitemDetail("Normal");

              // this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// itemMisRep.vue?2c7831d7